import { DEPLOY_REVISION } from "@/generated/deploy-revision";

/**
 * LaunchDarkly URLs use a literal `s` before the client-side id (e.g. `/eval/s{clientSideId}/…`).
 * If that segment is copied into NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_SIDE_ID, a
 * observabilidade LD falha com "failed to decode s…" e streaming retorna 404.
 */
const normalizeLaunchDarklyClientSideId = (raw: string): string => {
  const id = raw.trim();
  if (!id.startsWith("s")) {
    return id;
  }
  const rest = id.slice(1);
  if (/^[0-9a-f]+$/i.test(rest) && rest.length >= 20 && rest.length <= 32) {
    return rest;
  }
  return id;
};

interface ConfigInterface {
  client: {
    apis: {
      host: string;
    };
    launchDarkly: {
      clientSideId: string;
      serviceName: string;
      version: string;
    };
  };
  server: {
    apis: {
      host: string;
    };
  };
}

export default {
  client: {
    apis: {
      host: process.env?.NEXT_PUBLIC_MIDDLEWARE_URL || "",
    },
    launchDarkly: {
      // LD Observability requires the LaunchDarkly client-side ID (per environment in LD).
      clientSideId: normalizeLaunchDarklyClientSideId(
        process.env?.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_SIDE_ID || ""
      ),
      serviceName:
        process.env?.NEXT_PUBLIC_LAUNCHDARKLY_SERVICE_NAME || "tami-frontend",
      version: DEPLOY_REVISION,
    },
  },
  server: {
    apis: {
      host: process.env.BACKEND_URL,
    },
  },
} as ConfigInterface;
